const fetchApi = async (url: string, options?: RequestInit) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_URL}${url}`,
    options,
  )
  if (!response.ok) {
    throw new Error(response.statusText)
  }
  return response.json()
}

export default fetchApi
